import { Component, Input } from '@angular/core';

@Component({
    selector   : 'my-num',
    template: '<span>{{format()}}</span>'
})

export class NumComponent {

    @Input('publicId') publicId: string;

    constructor() {
    }

    public format() : string{
        return ("0".repeat(6 - this.publicId.toString().length)) + '' + this.publicId;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/num/num.component.ts